import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Code2 } from "lucide-react";

interface AddVbaCodeModalProps {
  onAddCode: () => void;
}

export const AddVbaCodeModal = ({ onAddCode }: AddVbaCodeModalProps) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Check if modal has been shown in this session
    const hasSeenModal = sessionStorage.getItem("hasSeenVbaModal");
    if (!hasSeenModal) {
      setOpen(true);
      sessionStorage.setItem("hasSeenVbaModal", "true");
    }
  }, []);

  const handleAddCode = () => {
    setOpen(false);
    onAddCode();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Code2 className="h-5 w-5" />
            Add Your VBA Code
          </DialogTitle>
          <DialogDescription className="pt-2">
            Before you publish, add at least one VBA module so other users can understand and use your macro.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={() => setOpen(false)}
            className="w-full sm:w-auto"
          >
            Skip for now
          </Button>
          <Button
            type="button"
            onClick={handleAddCode}
            className="w-full sm:w-auto"
          >
            Add VBA Code
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
